import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './common/Button';

const SuccessMessage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-2xl w-full">
                {/* Success Message */}
                <div className="text-2xl font-bold text-green-600 mb-4">
                    Your Demo account has been successfully created!
                </div>

                {/* Additional Info */}
                <div className="text-gray-700 mb-4">
                    One of our team members will contact you shortly to assist you further.
                </div>

                {/* Support Contact */}
                <div className="text-gray-700 mb-4">
                    For support, please contact us at:<br />
                    <strong className="text-primary">support@investain.com</strong>
                </div>

                {/* Social Media Links */}
                <div className="text-gray-700 mb-4">
                    Follow us on social media:
                </div>
                <div className="flex justify-center space-x-4 mb-4">
                    <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline"
                    >
                        Facebook
                    </a>
                    <span>|</span>
                    <a
                        href="https://www.x.com/investain_com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline"
                    >
                        Twitter
                    </a>
                    <span>|</span>
                    <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline"
                    >
                        Instagram
                    </a>
                </div>

                {/* Return to Home Button */}
                <Button
                    onClick={() => navigate('/')}
                   width='w-48'>
                    Return to Home
                </Button>
            </div>
        </div>
    );
};

export default SuccessMessage;